import { useState } from "react";
import { Mail, Phone, Send } from "lucide-react";
import { toast } from "sonner";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { LeadFacts } from "@/components/partners/LeadCard";
import { api, formatApiError } from "@/lib/api";
import { useFormat } from "@/lib/format";

const OFFER_STATUS = { pending: "Envoyée, en attente du client", accepted: "Acceptée par le client" };

const OfferForm = ({ lead, onDone }) => {
  const o = lead.my_offer;
  const [v, setV] = useState({ title: o?.title || "", price_monthly: o?.price_monthly || "", details: o?.details || "" });
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post(`/partners/leads/${lead.id}/offer`, { ...v, price_monthly: Number(v.price_monthly), details: v.details || null }); toast.success("Offre envoyée au client"); onDone(); }
    catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <form onSubmit={submit} className="mt-3 space-y-2 rounded-xl border border-dashed border-border p-3" data-testid={`offer-form-${lead.id}`}>
      <div className="grid gap-2 sm:grid-cols-[1fr_9rem]">
        <Input value={v.title} onChange={(e) => setV({ ...v, title: e.target.value })} placeholder="Nom de l'offre (ex. Fibre 1 Gb/s)" required minLength={2} data-testid="offer-title" />
        <Input type="number" min="0.01" step="0.01" value={v.price_monthly} onChange={(e) => setV({ ...v, price_monthly: e.target.value })} placeholder="€/mois" required data-testid="offer-price" />
      </div>
      <Textarea value={v.details} onChange={(e) => setV({ ...v, details: e.target.value })} maxLength={600} rows={2} placeholder="Détails : engagement, garanties, frais…" data-testid="offer-details" />
      <Button type="submit" size="sm" className="rounded-full" data-testid="offer-submit"><Send className="mr-1 h-3.5 w-3.5" /> {o ? "Mettre à jour l'offre" : "Envoyer l'offre"}</Button>
    </form>
  );
};

export const PurchasedLead = ({ lead, onChange }) => {
  const { money, date } = useFormat();
  const o = lead.my_offer;
  return (
    <li className="card-surface p-5" data-testid={`bought-lead-${lead.id}`}>
      <LeadFacts lead={lead} />
      <div className="mt-4 rounded-xl bg-success/10 p-3 text-sm" data-testid={`lead-contact-${lead.id}`}>
        <div className="font-semibold">{lead.contact.name}</div>
        <a href={`tel:${lead.contact.phone.replace(/\s/g, "")}`} className="mt-1 flex items-center gap-1.5 hover:underline"><Phone className="h-3.5 w-3.5" /> {lead.contact.phone}</a>
        <a href={`mailto:${lead.contact.email}`} className="flex items-center gap-1.5 hover:underline"><Mail className="h-3.5 w-3.5" /> {lead.contact.email}</a>
        <div className="mt-1 text-[11px] text-muted-foreground">Acheté le {date(lead.purchase.paid_at)} · {lead.purchase.mode === "exclusive" ? "exclusif" : "partagé"} · {money(lead.purchase.amount)}</div>
      </div>
      {o && <div className="mt-3 flex flex-wrap items-center gap-2 text-xs"><Badge variant={o.status === "accepted" ? "default" : "secondary"} className="rounded-full" data-testid={`my-offer-status-${lead.id}`}>{OFFER_STATUS[o.status]}</Badge>{o.title} · <b className="num">{money(o.price_monthly, { maximumFractionDigits: 2 })}/mois</b></div>}
      {o?.status !== "accepted" && lead.status !== "cancelled" && <OfferForm lead={lead} onDone={onChange} />}
      {lead.status === "cancelled" && <p className="mt-3 text-xs text-muted-foreground">Le client a retiré sa demande.</p>}
    </li>
  );
};
